/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as HealthCheckRouteImport } from './routes/health-check'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthCreatePasswordRouteImport } from './routes/auth/create-password'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedJobsRouteImport } from './routes/_authenticated/jobs'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedObjectivesIndexRouteImport } from './routes/_authenticated/objectives/index'
import { Route as AuthenticatedApplicantsIndexRouteImport } from './routes/_authenticated/applicants/index'
import { Route as AuthenticatedSettingsRecruitersRouteImport } from './routes/_authenticated/settings/recruiters'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings/integrations'
import { Route as AuthenticatedSettingsEmailsTemplatesRouteImport } from './routes/_authenticated/settings/emails-templates'
import { Route as AuthenticatedSettingsCrmRouteImport } from './routes/_authenticated/settings/crm'
import { Route as AuthenticatedSettings4v3ntAdm1nRouteImport } from './routes/_authenticated/settings/4v3ntAdm1n'
import { Route as AuthenticatedObjectivesToPrioritizeRouteImport } from './routes/_authenticated/objectives/to-prioritize'
import { Route as AuthenticatedObjectivesToFinalizeRouteImport } from './routes/_authenticated/objectives/to-finalize'
import { Route as AuthenticatedJobsCreateRouteImport } from './routes/_authenticated/jobs_/create'
import { Route as AuthenticatedJobsJobIdRouteImport } from './routes/_authenticated/jobs_/$jobId'
import { Route as AuthenticatedApplicantsApplicantIdRouteImport } from './routes/_authenticated/applicants/$applicantId'
import { Route as AuthenticatedJobsJobIdEditRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit'
import { Route as AuthenticatedApplicantsTagsTagIdRouteImport } from './routes/_authenticated/applicants/tags.$tagId'
import { Route as AuthenticatedApplicantsEligibleRolesEligibleRoleIdRouteImport } from './routes/_authenticated/applicants/eligible-roles.$eligibleRoleId'
import { Route as AuthenticatedJobsJobIdEditIndexRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/index'
import { Route as AuthenticatedJobsJobIdEditStagesRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/stages'
import { Route as AuthenticatedJobsJobIdEditRecruitersRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/recruiters'
import { Route as AuthenticatedJobsJobIdEditQualificationRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/qualification'
import { Route as AuthenticatedJobsJobIdEditInternalInformationsRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/internal-informations'
import { Route as AuthenticatedJobsJobIdEditDescriptionRouteImport } from './routes/_authenticated/jobs_/$jobId_/edit/description'
import { Route as AuthenticatedJobsJobIdApplicationsApplicationIdRouteImport } from './routes/_authenticated/jobs_/$jobId.applications.$applicationId'

const HealthCheckRoute = HealthCheckRouteImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreatePasswordRoute = AuthCreatePasswordRouteImport.update({
  id: '/create-password',
  path: '/create-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsRoute = AuthenticatedJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/jobs.lazy').then((d) => d.Route),
)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedObjectivesIndexRoute =
  AuthenticatedObjectivesIndexRouteImport.update({
    id: '/objectives/',
    path: '/objectives/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicantsIndexRoute =
  AuthenticatedApplicantsIndexRouteImport.update({
    id: '/applicants/',
    path: '/applicants/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRecruitersRoute =
  AuthenticatedSettingsRecruitersRouteImport.update({
    id: '/recruiters',
    path: '/recruiters',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsIntegrationsRoute =
  AuthenticatedSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsEmailsTemplatesRoute =
  AuthenticatedSettingsEmailsTemplatesRouteImport.update({
    id: '/emails-templates',
    path: '/emails-templates',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsCrmRoute =
  AuthenticatedSettingsCrmRouteImport.update({
    id: '/crm',
    path: '/crm',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettings4v3ntAdm1nRoute =
  AuthenticatedSettings4v3ntAdm1nRouteImport.update({
    id: '/4v3ntAdm1n',
    path: '/4v3ntAdm1n',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedObjectivesToPrioritizeRoute =
  AuthenticatedObjectivesToPrioritizeRouteImport.update({
    id: '/objectives/to-prioritize',
    path: '/objectives/to-prioritize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedObjectivesToFinalizeRoute =
  AuthenticatedObjectivesToFinalizeRouteImport.update({
    id: '/objectives/to-finalize',
    path: '/objectives/to-finalize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsCreateRoute = AuthenticatedJobsCreateRouteImport.update({
  id: '/jobs_/create',
  path: '/jobs/create',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsJobIdRoute = AuthenticatedJobsJobIdRouteImport.update({
  id: '/jobs_/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/jobs_/$jobId.lazy').then((d) => d.Route),
)
const AuthenticatedApplicantsApplicantIdRoute =
  AuthenticatedApplicantsApplicantIdRouteImport.update({
    id: '/applicants/$applicantId',
    path: '/applicants/$applicantId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsJobIdEditRoute =
  AuthenticatedJobsJobIdEditRouteImport.update({
    id: '/jobs_/$jobId_/edit',
    path: '/jobs/$jobId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicantsTagsTagIdRoute =
  AuthenticatedApplicantsTagsTagIdRouteImport.update({
    id: '/applicants/tags/$tagId',
    path: '/applicants/tags/$tagId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute =
  AuthenticatedApplicantsEligibleRolesEligibleRoleIdRouteImport.update({
    id: '/applicants/eligible-roles/$eligibleRoleId',
    path: '/applicants/eligible-roles/$eligibleRoleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsJobIdEditIndexRoute =
  AuthenticatedJobsJobIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any)
const AuthenticatedJobsJobIdEditStagesRoute =
  AuthenticatedJobsJobIdEditStagesRouteImport.update({
    id: '/stages',
    path: '/stages',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any)
const AuthenticatedJobsJobIdEditRecruitersRoute =
  AuthenticatedJobsJobIdEditRecruitersRouteImport.update({
    id: '/recruiters',
    path: '/recruiters',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs_/$jobId_/edit/recruiters.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdEditQualificationRoute =
  AuthenticatedJobsJobIdEditQualificationRouteImport.update({
    id: '/qualification',
    path: '/qualification',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any)
const AuthenticatedJobsJobIdEditInternalInformationsRoute =
  AuthenticatedJobsJobIdEditInternalInformationsRouteImport.update({
    id: '/internal-informations',
    path: '/internal-informations',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs_/$jobId_/edit/internal-informations.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdEditDescriptionRoute =
  AuthenticatedJobsJobIdEditDescriptionRouteImport.update({
    id: '/description',
    path: '/description',
    getParentRoute: () => AuthenticatedJobsJobIdEditRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs_/$jobId_/edit/description.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdApplicationsApplicationIdRoute =
  AuthenticatedJobsJobIdApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthenticatedJobsJobIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/jobs': typeof AuthenticatedJobsRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/': typeof AuthenticatedIndexRoute
  '/applicants/$applicantId': typeof AuthenticatedApplicantsApplicantIdRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteWithChildren
  '/jobs/create': typeof AuthenticatedJobsCreateRoute
  '/objectives/to-finalize': typeof AuthenticatedObjectivesToFinalizeRoute
  '/objectives/to-prioritize': typeof AuthenticatedObjectivesToPrioritizeRoute
  '/settings/4v3ntAdm1n': typeof AuthenticatedSettings4v3ntAdm1nRoute
  '/settings/crm': typeof AuthenticatedSettingsCrmRoute
  '/settings/emails-templates': typeof AuthenticatedSettingsEmailsTemplatesRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/recruiters': typeof AuthenticatedSettingsRecruitersRoute
  '/applicants': typeof AuthenticatedApplicantsIndexRoute
  '/objectives': typeof AuthenticatedObjectivesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/applicants/eligible-roles/$eligibleRoleId': typeof AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute
  '/applicants/tags/$tagId': typeof AuthenticatedApplicantsTagsTagIdRoute
  '/jobs/$jobId/edit': typeof AuthenticatedJobsJobIdEditRouteWithChildren
  '/jobs/$jobId/applications/$applicationId': typeof AuthenticatedJobsJobIdApplicationsApplicationIdRoute
  '/jobs/$jobId/edit/description': typeof AuthenticatedJobsJobIdEditDescriptionRoute
  '/jobs/$jobId/edit/internal-informations': typeof AuthenticatedJobsJobIdEditInternalInformationsRoute
  '/jobs/$jobId/edit/qualification': typeof AuthenticatedJobsJobIdEditQualificationRoute
  '/jobs/$jobId/edit/recruiters': typeof AuthenticatedJobsJobIdEditRecruitersRoute
  '/jobs/$jobId/edit/stages': typeof AuthenticatedJobsJobIdEditStagesRoute
  '/jobs/$jobId/edit/': typeof AuthenticatedJobsJobIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/jobs': typeof AuthenticatedJobsRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/': typeof AuthenticatedIndexRoute
  '/applicants/$applicantId': typeof AuthenticatedApplicantsApplicantIdRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteWithChildren
  '/jobs/create': typeof AuthenticatedJobsCreateRoute
  '/objectives/to-finalize': typeof AuthenticatedObjectivesToFinalizeRoute
  '/objectives/to-prioritize': typeof AuthenticatedObjectivesToPrioritizeRoute
  '/settings/4v3ntAdm1n': typeof AuthenticatedSettings4v3ntAdm1nRoute
  '/settings/crm': typeof AuthenticatedSettingsCrmRoute
  '/settings/emails-templates': typeof AuthenticatedSettingsEmailsTemplatesRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/recruiters': typeof AuthenticatedSettingsRecruitersRoute
  '/applicants': typeof AuthenticatedApplicantsIndexRoute
  '/objectives': typeof AuthenticatedObjectivesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/applicants/eligible-roles/$eligibleRoleId': typeof AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute
  '/applicants/tags/$tagId': typeof AuthenticatedApplicantsTagsTagIdRoute
  '/jobs/$jobId/applications/$applicationId': typeof AuthenticatedJobsJobIdApplicationsApplicationIdRoute
  '/jobs/$jobId/edit/description': typeof AuthenticatedJobsJobIdEditDescriptionRoute
  '/jobs/$jobId/edit/internal-informations': typeof AuthenticatedJobsJobIdEditInternalInformationsRoute
  '/jobs/$jobId/edit/qualification': typeof AuthenticatedJobsJobIdEditQualificationRoute
  '/jobs/$jobId/edit/recruiters': typeof AuthenticatedJobsJobIdEditRecruitersRoute
  '/jobs/$jobId/edit/stages': typeof AuthenticatedJobsJobIdEditStagesRoute
  '/jobs/$jobId/edit': typeof AuthenticatedJobsJobIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/_authenticated/jobs': typeof AuthenticatedJobsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/applicants/$applicantId': typeof AuthenticatedApplicantsApplicantIdRoute
  '/_authenticated/jobs_/$jobId': typeof AuthenticatedJobsJobIdRouteWithChildren
  '/_authenticated/jobs_/create': typeof AuthenticatedJobsCreateRoute
  '/_authenticated/objectives/to-finalize': typeof AuthenticatedObjectivesToFinalizeRoute
  '/_authenticated/objectives/to-prioritize': typeof AuthenticatedObjectivesToPrioritizeRoute
  '/_authenticated/settings/4v3ntAdm1n': typeof AuthenticatedSettings4v3ntAdm1nRoute
  '/_authenticated/settings/crm': typeof AuthenticatedSettingsCrmRoute
  '/_authenticated/settings/emails-templates': typeof AuthenticatedSettingsEmailsTemplatesRoute
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/_authenticated/settings/recruiters': typeof AuthenticatedSettingsRecruitersRoute
  '/_authenticated/applicants/': typeof AuthenticatedApplicantsIndexRoute
  '/_authenticated/objectives/': typeof AuthenticatedObjectivesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/applicants/eligible-roles/$eligibleRoleId': typeof AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute
  '/_authenticated/applicants/tags/$tagId': typeof AuthenticatedApplicantsTagsTagIdRoute
  '/_authenticated/jobs_/$jobId_/edit': typeof AuthenticatedJobsJobIdEditRouteWithChildren
  '/_authenticated/jobs_/$jobId/applications/$applicationId': typeof AuthenticatedJobsJobIdApplicationsApplicationIdRoute
  '/_authenticated/jobs_/$jobId_/edit/description': typeof AuthenticatedJobsJobIdEditDescriptionRoute
  '/_authenticated/jobs_/$jobId_/edit/internal-informations': typeof AuthenticatedJobsJobIdEditInternalInformationsRoute
  '/_authenticated/jobs_/$jobId_/edit/qualification': typeof AuthenticatedJobsJobIdEditQualificationRoute
  '/_authenticated/jobs_/$jobId_/edit/recruiters': typeof AuthenticatedJobsJobIdEditRecruitersRoute
  '/_authenticated/jobs_/$jobId_/edit/stages': typeof AuthenticatedJobsJobIdEditStagesRoute
  '/_authenticated/jobs_/$jobId_/edit/': typeof AuthenticatedJobsJobIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/health-check'
    | '/jobs'
    | '/settings'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/'
    | '/applicants/$applicantId'
    | '/jobs/$jobId'
    | '/jobs/create'
    | '/objectives/to-finalize'
    | '/objectives/to-prioritize'
    | '/settings/4v3ntAdm1n'
    | '/settings/crm'
    | '/settings/emails-templates'
    | '/settings/integrations'
    | '/settings/recruiters'
    | '/applicants'
    | '/objectives'
    | '/settings/'
    | '/applicants/eligible-roles/$eligibleRoleId'
    | '/applicants/tags/$tagId'
    | '/jobs/$jobId/edit'
    | '/jobs/$jobId/applications/$applicationId'
    | '/jobs/$jobId/edit/description'
    | '/jobs/$jobId/edit/internal-informations'
    | '/jobs/$jobId/edit/qualification'
    | '/jobs/$jobId/edit/recruiters'
    | '/jobs/$jobId/edit/stages'
    | '/jobs/$jobId/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/health-check'
    | '/jobs'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/'
    | '/applicants/$applicantId'
    | '/jobs/$jobId'
    | '/jobs/create'
    | '/objectives/to-finalize'
    | '/objectives/to-prioritize'
    | '/settings/4v3ntAdm1n'
    | '/settings/crm'
    | '/settings/emails-templates'
    | '/settings/integrations'
    | '/settings/recruiters'
    | '/applicants'
    | '/objectives'
    | '/settings'
    | '/applicants/eligible-roles/$eligibleRoleId'
    | '/applicants/tags/$tagId'
    | '/jobs/$jobId/applications/$applicationId'
    | '/jobs/$jobId/edit/description'
    | '/jobs/$jobId/edit/internal-informations'
    | '/jobs/$jobId/edit/qualification'
    | '/jobs/$jobId/edit/recruiters'
    | '/jobs/$jobId/edit/stages'
    | '/jobs/$jobId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/health-check'
    | '/_authenticated/jobs'
    | '/_authenticated/settings'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/_authenticated/'
    | '/_authenticated/applicants/$applicantId'
    | '/_authenticated/jobs_/$jobId'
    | '/_authenticated/jobs_/create'
    | '/_authenticated/objectives/to-finalize'
    | '/_authenticated/objectives/to-prioritize'
    | '/_authenticated/settings/4v3ntAdm1n'
    | '/_authenticated/settings/crm'
    | '/_authenticated/settings/emails-templates'
    | '/_authenticated/settings/integrations'
    | '/_authenticated/settings/recruiters'
    | '/_authenticated/applicants/'
    | '/_authenticated/objectives/'
    | '/_authenticated/settings/'
    | '/_authenticated/applicants/eligible-roles/$eligibleRoleId'
    | '/_authenticated/applicants/tags/$tagId'
    | '/_authenticated/jobs_/$jobId_/edit'
    | '/_authenticated/jobs_/$jobId/applications/$applicationId'
    | '/_authenticated/jobs_/$jobId_/edit/description'
    | '/_authenticated/jobs_/$jobId_/edit/internal-informations'
    | '/_authenticated/jobs_/$jobId_/edit/qualification'
    | '/_authenticated/jobs_/$jobId_/edit/recruiters'
    | '/_authenticated/jobs_/$jobId_/edit/stages'
    | '/_authenticated/jobs_/$jobId_/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  HealthCheckRoute: typeof HealthCheckRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/health-check': {
      id: '/health-check'
      path: '/health-check'
      fullPath: '/health-check'
      preLoaderRoute: typeof HealthCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/create-password': {
      id: '/auth/create-password'
      path: '/create-password'
      fullPath: '/auth/create-password'
      preLoaderRoute: typeof AuthCreatePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs': {
      id: '/_authenticated/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/objectives/': {
      id: '/_authenticated/objectives/'
      path: '/objectives'
      fullPath: '/objectives'
      preLoaderRoute: typeof AuthenticatedObjectivesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applicants/': {
      id: '/_authenticated/applicants/'
      path: '/applicants'
      fullPath: '/applicants'
      preLoaderRoute: typeof AuthenticatedApplicantsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/recruiters': {
      id: '/_authenticated/settings/recruiters'
      path: '/recruiters'
      fullPath: '/settings/recruiters'
      preLoaderRoute: typeof AuthenticatedSettingsRecruitersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/emails-templates': {
      id: '/_authenticated/settings/emails-templates'
      path: '/emails-templates'
      fullPath: '/settings/emails-templates'
      preLoaderRoute: typeof AuthenticatedSettingsEmailsTemplatesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/crm': {
      id: '/_authenticated/settings/crm'
      path: '/crm'
      fullPath: '/settings/crm'
      preLoaderRoute: typeof AuthenticatedSettingsCrmRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/4v3ntAdm1n': {
      id: '/_authenticated/settings/4v3ntAdm1n'
      path: '/4v3ntAdm1n'
      fullPath: '/settings/4v3ntAdm1n'
      preLoaderRoute: typeof AuthenticatedSettings4v3ntAdm1nRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/objectives/to-prioritize': {
      id: '/_authenticated/objectives/to-prioritize'
      path: '/objectives/to-prioritize'
      fullPath: '/objectives/to-prioritize'
      preLoaderRoute: typeof AuthenticatedObjectivesToPrioritizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/objectives/to-finalize': {
      id: '/_authenticated/objectives/to-finalize'
      path: '/objectives/to-finalize'
      fullPath: '/objectives/to-finalize'
      preLoaderRoute: typeof AuthenticatedObjectivesToFinalizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs_/create': {
      id: '/_authenticated/jobs_/create'
      path: '/jobs/create'
      fullPath: '/jobs/create'
      preLoaderRoute: typeof AuthenticatedJobsCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs_/$jobId': {
      id: '/_authenticated/jobs_/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applicants/$applicantId': {
      id: '/_authenticated/applicants/$applicantId'
      path: '/applicants/$applicantId'
      fullPath: '/applicants/$applicantId'
      preLoaderRoute: typeof AuthenticatedApplicantsApplicantIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs_/$jobId_/edit': {
      id: '/_authenticated/jobs_/$jobId_/edit'
      path: '/jobs/$jobId/edit'
      fullPath: '/jobs/$jobId/edit'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applicants/tags/$tagId': {
      id: '/_authenticated/applicants/tags/$tagId'
      path: '/applicants/tags/$tagId'
      fullPath: '/applicants/tags/$tagId'
      preLoaderRoute: typeof AuthenticatedApplicantsTagsTagIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applicants/eligible-roles/$eligibleRoleId': {
      id: '/_authenticated/applicants/eligible-roles/$eligibleRoleId'
      path: '/applicants/eligible-roles/$eligibleRoleId'
      fullPath: '/applicants/eligible-roles/$eligibleRoleId'
      preLoaderRoute: typeof AuthenticatedApplicantsEligibleRolesEligibleRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/': {
      id: '/_authenticated/jobs_/$jobId_/edit/'
      path: '/'
      fullPath: '/jobs/$jobId/edit/'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/stages': {
      id: '/_authenticated/jobs_/$jobId_/edit/stages'
      path: '/stages'
      fullPath: '/jobs/$jobId/edit/stages'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditStagesRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/recruiters': {
      id: '/_authenticated/jobs_/$jobId_/edit/recruiters'
      path: '/recruiters'
      fullPath: '/jobs/$jobId/edit/recruiters'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditRecruitersRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/qualification': {
      id: '/_authenticated/jobs_/$jobId_/edit/qualification'
      path: '/qualification'
      fullPath: '/jobs/$jobId/edit/qualification'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditQualificationRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/internal-informations': {
      id: '/_authenticated/jobs_/$jobId_/edit/internal-informations'
      path: '/internal-informations'
      fullPath: '/jobs/$jobId/edit/internal-informations'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditInternalInformationsRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId_/edit/description': {
      id: '/_authenticated/jobs_/$jobId_/edit/description'
      path: '/description'
      fullPath: '/jobs/$jobId/edit/description'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditDescriptionRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdEditRoute
    }
    '/_authenticated/jobs_/$jobId/applications/$applicationId': {
      id: '/_authenticated/jobs_/$jobId/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/jobs/$jobId/applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRoute
    }
  }
}

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettings4v3ntAdm1nRoute: typeof AuthenticatedSettings4v3ntAdm1nRoute
  AuthenticatedSettingsCrmRoute: typeof AuthenticatedSettingsCrmRoute
  AuthenticatedSettingsEmailsTemplatesRoute: typeof AuthenticatedSettingsEmailsTemplatesRoute
  AuthenticatedSettingsIntegrationsRoute: typeof AuthenticatedSettingsIntegrationsRoute
  AuthenticatedSettingsRecruitersRoute: typeof AuthenticatedSettingsRecruitersRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettings4v3ntAdm1nRoute: AuthenticatedSettings4v3ntAdm1nRoute,
  AuthenticatedSettingsCrmRoute: AuthenticatedSettingsCrmRoute,
  AuthenticatedSettingsEmailsTemplatesRoute:
    AuthenticatedSettingsEmailsTemplatesRoute,
  AuthenticatedSettingsIntegrationsRoute:
    AuthenticatedSettingsIntegrationsRoute,
  AuthenticatedSettingsRecruitersRoute: AuthenticatedSettingsRecruitersRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedJobsJobIdRouteChildren {
  AuthenticatedJobsJobIdApplicationsApplicationIdRoute: typeof AuthenticatedJobsJobIdApplicationsApplicationIdRoute
}

const AuthenticatedJobsJobIdRouteChildren: AuthenticatedJobsJobIdRouteChildren =
  {
    AuthenticatedJobsJobIdApplicationsApplicationIdRoute:
      AuthenticatedJobsJobIdApplicationsApplicationIdRoute,
  }

const AuthenticatedJobsJobIdRouteWithChildren =
  AuthenticatedJobsJobIdRoute._addFileChildren(
    AuthenticatedJobsJobIdRouteChildren,
  )

interface AuthenticatedJobsJobIdEditRouteChildren {
  AuthenticatedJobsJobIdEditDescriptionRoute: typeof AuthenticatedJobsJobIdEditDescriptionRoute
  AuthenticatedJobsJobIdEditInternalInformationsRoute: typeof AuthenticatedJobsJobIdEditInternalInformationsRoute
  AuthenticatedJobsJobIdEditQualificationRoute: typeof AuthenticatedJobsJobIdEditQualificationRoute
  AuthenticatedJobsJobIdEditRecruitersRoute: typeof AuthenticatedJobsJobIdEditRecruitersRoute
  AuthenticatedJobsJobIdEditStagesRoute: typeof AuthenticatedJobsJobIdEditStagesRoute
  AuthenticatedJobsJobIdEditIndexRoute: typeof AuthenticatedJobsJobIdEditIndexRoute
}

const AuthenticatedJobsJobIdEditRouteChildren: AuthenticatedJobsJobIdEditRouteChildren =
  {
    AuthenticatedJobsJobIdEditDescriptionRoute:
      AuthenticatedJobsJobIdEditDescriptionRoute,
    AuthenticatedJobsJobIdEditInternalInformationsRoute:
      AuthenticatedJobsJobIdEditInternalInformationsRoute,
    AuthenticatedJobsJobIdEditQualificationRoute:
      AuthenticatedJobsJobIdEditQualificationRoute,
    AuthenticatedJobsJobIdEditRecruitersRoute:
      AuthenticatedJobsJobIdEditRecruitersRoute,
    AuthenticatedJobsJobIdEditStagesRoute:
      AuthenticatedJobsJobIdEditStagesRoute,
    AuthenticatedJobsJobIdEditIndexRoute: AuthenticatedJobsJobIdEditIndexRoute,
  }

const AuthenticatedJobsJobIdEditRouteWithChildren =
  AuthenticatedJobsJobIdEditRoute._addFileChildren(
    AuthenticatedJobsJobIdEditRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedJobsRoute: typeof AuthenticatedJobsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedApplicantsApplicantIdRoute: typeof AuthenticatedApplicantsApplicantIdRoute
  AuthenticatedJobsJobIdRoute: typeof AuthenticatedJobsJobIdRouteWithChildren
  AuthenticatedJobsCreateRoute: typeof AuthenticatedJobsCreateRoute
  AuthenticatedObjectivesToFinalizeRoute: typeof AuthenticatedObjectivesToFinalizeRoute
  AuthenticatedObjectivesToPrioritizeRoute: typeof AuthenticatedObjectivesToPrioritizeRoute
  AuthenticatedApplicantsIndexRoute: typeof AuthenticatedApplicantsIndexRoute
  AuthenticatedObjectivesIndexRoute: typeof AuthenticatedObjectivesIndexRoute
  AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute: typeof AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute
  AuthenticatedApplicantsTagsTagIdRoute: typeof AuthenticatedApplicantsTagsTagIdRoute
  AuthenticatedJobsJobIdEditRoute: typeof AuthenticatedJobsJobIdEditRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedJobsRoute: AuthenticatedJobsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedApplicantsApplicantIdRoute:
    AuthenticatedApplicantsApplicantIdRoute,
  AuthenticatedJobsJobIdRoute: AuthenticatedJobsJobIdRouteWithChildren,
  AuthenticatedJobsCreateRoute: AuthenticatedJobsCreateRoute,
  AuthenticatedObjectivesToFinalizeRoute:
    AuthenticatedObjectivesToFinalizeRoute,
  AuthenticatedObjectivesToPrioritizeRoute:
    AuthenticatedObjectivesToPrioritizeRoute,
  AuthenticatedApplicantsIndexRoute: AuthenticatedApplicantsIndexRoute,
  AuthenticatedObjectivesIndexRoute: AuthenticatedObjectivesIndexRoute,
  AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute:
    AuthenticatedApplicantsEligibleRolesEligibleRoleIdRoute,
  AuthenticatedApplicantsTagsTagIdRoute: AuthenticatedApplicantsTagsTagIdRoute,
  AuthenticatedJobsJobIdEditRoute: AuthenticatedJobsJobIdEditRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthRouteChildren {
  AuthCreatePasswordRoute: typeof AuthCreatePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCreatePasswordRoute: AuthCreatePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  HealthCheckRoute: HealthCheckRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
